import LoginCard from 'src/features/plugins/outlook/components/LoginCard';

export default function LoginPage() {
  return (
    <div className="w-full">
      <LoginCard />
    </div>
  );
}
